<template>
    <v-dialog
    v-model="shown"
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Komentar
      </v-card-title>

      <v-card-text>
        <form @submit.prevent="save">
          <v-row>
            <v-col>
              {{comment}}
            </v-col>
          </v-row>
          <div style="height: 30px; margin-top: 20px;">
            <v-btn text type="button" class="float-right mr-4" @click="close">V redu</v-btn>
          </div>
        </form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    comment: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      shown: false
    }
  },
  methods: {
    close () {
      this.shown = false
    },
    open () {
      this.shown = true
    }
  }
}
</script>
